<div class="page-layout carded fullwidth">
  <div class="center">
    <div class="header" fxLayout="row" fxLayoutAlign="space-between center">
      <span class="h1" [translate]="'DASHBOARD_EQUIPMENTS.TITLE'"> Equipments </span>

      <div class="page-buttons" fxHide.xs>
        <button
          mat-stroked-button
          matTooltip="{{ 'DASHBOARD_EQUIPMENTS.RELOAD' | translate }}"
          (click)="reload()"
          [disabled]="isLoading"
        >
          <i class="angularjs-fuse-icon icon-reload small"></i>
        </button>

        <button
          *ngIf="isFilterOn | async"
          mat-stroked-button
          matTooltip="{{ 'DASHBOARD_EQUIPMENTS.FILTERS.CLEAR' | translate }}"
          [disabled]="isLoading"
          (click)="clearFilters()"
        >
          <i class="angularjs-fuse-icon icon-filter-remove"></i>
        </button>

        <button
          mat-stroked-button
          matTooltip="{{ 'DASHBOARD_EQUIPMENTS.FILTERS.TITLE' | translate }}"
          (click)="sidenavService.open('filterDashboard')"
        >
          <i class="angularjs-fuse-icon icon-filter"></i>
        </button>
      </div>

      <div class="page-buttons" fxShow="false" fxShow.xs>
        <button mat-stroked-button [matMenuTriggerFor]="menuDashboard">
          <mat-icon class="accent-500-fg">keyboard_arrow_down</mat-icon>
        </button>

        <mat-menu #menuDashboard>
          <button mat-menu-item fxLayout="row" fxLayoutAlign="start center" (click)="reload()" [disabled]="isLoading">
            <i class="angularjs-fuse-icon icon-reload small mr-4"></i>
            <span [translate]="'DASHBOARD_EQUIPMENTS.RELOAD'">Reload</span>
          </button>

          <button
            *ngIf="isFilterOn | async"
            mat-menu-item
            fxLayout="row"
            fxLayoutAlign="start center"
            (click)="clearFilters()"
            [disabled]="isLoading"
          >
            <i class="angularjs-fuse-icon icon-filter-remove small mr-4"></i>
            <span [translate]="'DASHBOARD_EQUIPMENTS.FILTERS.CLEAR'">Clear filters</span>
          </button>

          <button
            mat-menu-item
            fxLayout="row"
            fxLayoutAlign="start center"
            (click)="sidenavService.open('filterDashboard')"
          >
            <i class="angularjs-fuse-icon icon-filter mr-4"></i>
            <span [translate]="'DASHBOARD_EQUIPMENTS.FILTERS.TITLE'">Filter</span>
          </button>
        </mat-menu>
      </div>
    </div>

    <div class="content-card">
      <div class="dashboard-equipments-container-column-3 p-16">
        <data-card
          [title]="'DASHBOARD_EQUIPMENTS.CARDS.MTBF' | translate"
          color="#858fa4"
          [data]="equipmentsIndicatorData?.mtbf | formatDuration: 'days'"
          [isLoading]="isLoading"
          [hideFooter]="true"
          [label]="
            ('DASHBOARD_EQUIPMENTS.IN_PERIOD_OF' | translate) +
            ' ' +
            (reportFilterState.query.openedAt_gte | humanizeDuration: reportFilterState.query.openedAt_lte)
          "
        >
        </data-card>

        <data-card
          [title]="'DASHBOARD_EQUIPMENTS.CARDS.MTTR' | translate"
          color="#0055ff"
          [data]="equipmentsIndicatorData?.mttr | formatDuration: 'days'"
          [isLoading]="isLoading"
          [hideFooter]="true"
          [label]="
            ('DASHBOARD_EQUIPMENTS.IN_PERIOD_OF' | translate) +
            ' ' +
            (reportFilterState.query.openedAt_gte | humanizeDuration: reportFilterState.query.openedAt_lte)
          "
        >
        </data-card>

        <data-card
          [title]="'DASHBOARD_EQUIPMENTS.CARDS.AVAILABILITY' | translate"
          color="#12b886"
          [data]="(equipmentsIndicatorData?.availability | number: '.2-2') + '%'"
          [isLoading]="isLoading"
          [hideFooter]="true"
          [label]="
            ('DASHBOARD_EQUIPMENTS.IN_PERIOD_OF' | translate) +
            ' ' +
            (reportFilterState.query.openedAt_gte | humanizeDuration: reportFilterState.query.openedAt_lte)
          "
        >
        </data-card>
      </div>
    </div>
  </div>
</div>

<fuse-sidebar
  class="sidebar-filter-fixed"
  name="filterDashboard"
  key="filterDashboard"
  position="right"
  lockedOpen="true"
>
  <filters class="sidebar-filter"></filters>
</fuse-sidebar>
